import { render, staticRenderFns } from "./resourcePreview.vue?vue&type=template&id=b6dbb7fa&scoped=true"
import script from "./resourcePreview.vue?vue&type=script&lang=js"
export * from "./resourcePreview.vue?vue&type=script&lang=js"
import style0 from "./resourcePreview.vue?vue&type=style&index=0&id=b6dbb7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dbb7fa",
  null
  
)

export default component.exports